import { useEffect, useState } from 'react';

const useSubmit = ({ loading, data, error, onSuccess, onError }) => {
  const [submitted, changeSubmitted] = useState(false);

  useEffect(() => {
    if (submitted && !loading && error) {
      changeSubmitted(false);
      if (onError) {
        onError();
      }
    } else if (submitted && !loading && data) {
      changeSubmitted(false);
      onSuccess();
    }
  }, [data, error, loading, onError, onSuccess, submitted]);

  return { changeStatus: changeSubmitted };
};

export default useSubmit;
